import DELETE from './api/delete'
import GET from './api/get'
import POST from './api/post'

export default {
  DELETE,
  GET,
  POST
}
